/* prettier-ignore */
/**
 * NOTE:
 *
 * This file is automatically generated by Traduki 2.0.
 * DO NOT CHANGE IT BY HAND or your changes will be lost.
 */
//Dutch (Netherlands)
export default {
  'editor-common-extensibility-extension-lozenge-editToggle.done.editing': 'Klaar met bewerken',
  'editor-common-extensibility-extension-lozenge-editToggle.make.edits': 'Bewerkingen maken',
  'editor-common-extensibility.macro.button.configure': '{macroName} configureren',
  'editor.extension.legacyContentHeader': 'Verouderde inhoud',
  'editor.extension.legacyContentHeader.contentHasLimitedFunctionality': 'Deze inhoud heeft beperkte functionaliteit,',
  'editor.extension.legacyContentHeader.learnMore': 'Meer informatie',
  'fablric.editor.viewAllInserts': 'Alle invoegbare elementen bekijken',
  'fabric.editor.action': 'Actiepunt',
  'fabric.editor.action.description': 'Actie-items maken en toewijzen',
  'fabric.editor.addAltText': 'Alt-tekst',
  'fabric.editor.addColumnLeft': 'Kolom links toevoegen',
  'fabric.editor.addColumnRight': 'Voeg kolom rechts toe',
  'fabric.editor.addCommentOnMedia': 'Opmerking toevoegen',
  'fabric.editor.addImageBorder': 'Kader toevoegen',
  'fabric.editor.addLoomVideo': 'Een Loom-video opnemen',
  'fabric.editor.addLoomVideoComment': 'Een Loom-video-opmerking opnemen',
  'fabric.editor.addMediaFiles': 'Afbeelding, video of bestand toevoegen',
  'fabric.editor.addRowAbove': 'Rij hierboven toevoegen',
  'fabric.editor.addRowBelow': 'Rij hieronder toevoegen',
  'fabric.editor.addUpdatedAltText': 'Alt-tekst toevoegen',
  'fabric.editor.ai.ai-panels.actionItemsPageDescription':
    'Gebruik Atlassian Intelligence om actie-items te zoeken en weer te geven in een paneel',
  'fabric.editor.ai.ai-panels.actionItemsPageTitle': 'Paneel met actie-items (bèta)',
  'fabric.editor.ai.ai-panels.summarizePageDescription':
    'Gebruik Atlassian Intelligence om deze pagina samen te vatten en weer te geven in een paneel',
  'fabric.editor.ai.ai-panels.summarizePageTitle': 'Pagina met paginasamenvatting (bèta)',
  'fabric.editor.ai.ai-smart-button.context.reference': 'Geselecteerde inhoud',
  'fabric.editor.ai.atlas-prebuilt.atlasGenerateContentConfigItemDescription':
    'Genereert inhoud die moet worden ingevoegd in de update',
  'fabric.editor.ai.atlas-prebuilt.atlasSummarizePageConfigItemDescription': 'Vat de inhoud van de update samen',
  'fabric.editor.ai.commandPalette.promptBuilderForm.buttons.submit': 'Genereren',
  'fabric.editor.ai.commandPalette.promptBuilderForm.generateContent.ariaLabel': 'Vragen aan Atlassian Intelligence',
  'fabric.editor.ai.config.item.action.edit': 'Bewerken',
  'fabric.editor.ai.config.item.action.insert': 'Invoegen',
  'fabric.editor.ai.config.item.action.insertAtTop': 'Bovenaan invoegen',
  'fabric.editor.ai.config.item.action.insertBelow': 'Onderaan invoegen',
  'fabric.editor.ai.config.item.action.insertBelowOriginal': 'Invoegen onder oorspronkelijke inhoud',
  'fabric.editor.ai.config.item.action.replace': 'Vervangen',
  'fabric.editor.ai.config.item.action.replaceTitle': 'Titel vervangen',
  'fabric.editor.ai.config.item.action.replaceTitleTooLongDisabledTooltip':
    'Titel mag niet langer dan {maxLength} tekens zijn',
  'fabric.editor.ai.config.item.action.rovoAgents.contineChatLabel': 'Verdergaan in chat',
  'fabric.editor.ai.config.item.action.rovoAgents.continueInChatLabel': 'Openen in de chat',
  'fabric.editor.ai.config.item.agent.title': 'Atlassian Intelligence Rovo Agent',
  'fabric.editor.ai.config.item.atlas-shorten-update.description': 'Maakt de inhoud korter en beknopter',
  'fabric.editor.ai.config.item.atlas-shorten-update.title': 'Update inkorten',
  'fabric.editor.ai.config.item.bb.pr.description.description':
    'Maakt een omschrijving van een pull request aan met een samenvatting van de wijzigingen',
  'fabric.editor.ai.config.item.bb.pr.description.title': 'Een omschrijving van een pull request aanmaken',
  'fabric.editor.ai.config.item.brainstorm.description':
    'Genereert een lijst met ideeën voor een onderwerp dat jij opgeeft',
  'fabric.editor.ai.config.item.brainstorm.promptHint': 'Vertel me over het onderwerp ...',
  'fabric.editor.ai.config.item.brainstorm.promptLabel': 'Brainstormen',
  'fabric.editor.ai.config.item.brainstorm.title': 'Brainstormen',
  'fabric.editor.ai.config.item.changeTone.casualTone.description': 'Verandert de toon van de inhoud naar informeel',
  'fabric.editor.ai.config.item.changeTone.casualTone.selectionToolbar.dropdownItem.title': 'Informeel',
  'fabric.editor.ai.config.item.changeTone.casualTone.shortTitle': 'Informeel',
  'fabric.editor.ai.config.item.changeTone.casualTone.title': 'De toon naar informeel veranderen',
  'fabric.editor.ai.config.item.changeTone.educationalTone.description':
    'Verandert de toon van de inhoud naar educatief',
  'fabric.editor.ai.config.item.changeTone.educationalTone.selectionToolbar.dropdownItem.title': 'Educatief',
  'fabric.editor.ai.config.item.changeTone.educationalTone.shortTitle': 'Educatief',
  'fabric.editor.ai.config.item.changeTone.educationalTone.title': 'De toon naar informatief veranderen',
  'fabric.editor.ai.config.item.changeTone.empatheticTone.description':
    'Verandert de toon van de inhoud naar empathisch',
  'fabric.editor.ai.config.item.changeTone.empatheticTone.selectionToolbar.dropdownItem.title': 'Empathisch',
  'fabric.editor.ai.config.item.changeTone.empatheticTone.shortTitle': 'Empathisch',
  'fabric.editor.ai.config.item.changeTone.empatheticTone.title': 'De toon naar empathisch veranderen',
  'fabric.editor.ai.config.item.changeTone.nestingParentTitlePostGA': 'De toon veranderen naar ...',
  'fabric.editor.ai.config.item.changeTone.neutralTone.description': 'Verandert de toon van de inhoud naar neutraal',
  'fabric.editor.ai.config.item.changeTone.neutralTone.selectionToolbar.dropdownItem.title': 'Neutraal',
  'fabric.editor.ai.config.item.changeTone.neutralTone.shortTitle': 'Neutraal',
  'fabric.editor.ai.config.item.changeTone.neutralTone.title': 'De toon naar neutraal veranderen',
  'fabric.editor.ai.config.item.changeTone.professionalTone.description':
    'Verandert de toon van de inhoud naar professioneel',
  'fabric.editor.ai.config.item.changeTone.professionalTone.selectionToolbar.dropdownItem.title': 'Professioneel',
  'fabric.editor.ai.config.item.changeTone.professionalTone.shortTitle': 'Professioneel',
  'fabric.editor.ai.config.item.changeTone.professionalTone.title': 'De toon naar professioneel veranderen',
  'fabric.editor.ai.config.item.convertToBulletList.description':
    'Verandert de opmaak van inhoud naar een lijst met opsommingstekens',
  'fabric.editor.ai.config.item.convertToBulletList.title': 'Omzetten naar een lijst met opsommingstekens',
  'fabric.editor.ai.config.item.convertToTable.description':
    'Verandert de opmaak van inhoud naar een tabel met kopteksten',
  'fabric.editor.ai.config.item.convertToTable.title': 'Omzetten naar tabel',
  'fabric.editor.ai.config.item.draftReply.description':
    'Stelt een antwoord op gebaseerd op vergelijkbare issues als waar je mee bezig bent',
  'fabric.editor.ai.config.item.draftReply.title': 'Antwoord opstellen',
  'fabric.editor.ai.config.item.enhance.fixSpellingGrammar.description': 'Verbetert spel- en grammaticale fouten',
  'fabric.editor.ai.config.item.enhance.fixSpellingGrammar.selectionToolbar.dropdownItem.title':
    'Spelling en grammatica',
  'fabric.editor.ai.config.item.enhance.fixSpellingGrammar.title': 'Spelling en grammatica corrigeren',
  'fabric.editor.ai.config.item.enhance.improveWriting.description':
    'Verbetert duidelijkheid, structuur en toon voor een betere betrokkenheid en een beter begrip',
  'fabric.editor.ai.config.item.enhance.improveWriting.selectionToolbar.dropdownItem.title': 'Schrijfstijl verbeteren',
  'fabric.editor.ai.config.item.enhance.improveWriting.title': 'Schrijfstijl verbeteren',
  'fabric.editor.ai.config.item.findActionItems.description': 'Vindt actie-items in de inhoud die je biedt',
  'fabric.editor.ai.config.item.findActionItems.title': 'Actie-items vinden',
  'fabric.editor.ai.config.item.freeGenerate.disabled.promptHint':
    'Selecteer een van de onderstaande opties (vrij genereren is momenteel uitgeschakeld in Elevate)',
  'fabric.editor.ai.config.item.generateContent.promptHint': 'Schrijf met AI of selecteer een onderstaande optie',
  'fabric.editor.ai.config.item.improveDescription.default.description':
    'Herstructureer de issue-omschrijving op basis van het issuetype',
  'fabric.editor.ai.config.item.improveDescription.default.title.experiment.one': 'Omschrijving verbeteren',
  'fabric.editor.ai.config.item.makeLonger.description': 'Breidt de inhoud uit op basis van de context die je opgeeft',
  'fabric.editor.ai.config.item.makeLonger.title': 'Maak langer',
  'fabric.editor.ai.config.item.range.agent.description': 'Geen omschrijving',
  'fabric.editor.ai.config.item.range.agent.prompt.hint':
    'Typ wat de Agent moet schrijven of selecteer hieronder een prompt',
  'fabric.editor.ai.config.item.rephrase.description': 'Maakt een suggestie aan om je zinnen te herschrijven',
  'fabric.editor.ai.config.item.rephrase.title': 'Herformuleer',
  'fabric.editor.ai.config.item.shorten.description': 'Maakt de inhoud korter en beknopter',
  'fabric.editor.ai.config.item.shorten.selectionToolbar.dropdownItem.title': 'Korter maken',
  'fabric.editor.ai.config.item.shorten.title': 'Korter maken',
  'fabric.editor.ai.config.item.suggest.description': 'Stelt een titel voor voor inhoud die je biedt',
  'fabric.editor.ai.config.item.suggest.title': 'Een titel voorstellen',
  'fabric.editor.ai.config.item.summarize.description':
    'Schrijft een samenvatting van de tekst waar je aan werkt en benadrukt de belangrijkste punten',
  'fabric.editor.ai.config.item.summarize.dropdownItem.title': 'Tekst samenvatten',
  'fabric.editor.ai.config.item.summarize.title': 'Tekst samenvatten',
  'fabric.editor.ai.config.item.translate.czech': 'Tsjechisch',
  'fabric.editor.ai.config.item.translate.danish': 'Deens',
  'fabric.editor.ai.config.item.translate.dutch': 'Nederlands',
  'fabric.editor.ai.config.item.translate.english': 'Engels',
  'fabric.editor.ai.config.item.translate.finnish': 'Fins',
  'fabric.editor.ai.config.item.translate.french': 'Frans',
  'fabric.editor.ai.config.item.translate.german': 'Duits',
  'fabric.editor.ai.config.item.translate.hungarian': 'Hongaars',
  'fabric.editor.ai.config.item.translate.italian': 'Italiaans',
  'fabric.editor.ai.config.item.translate.japanese': 'Japans',
  'fabric.editor.ai.config.item.translate.nestingParentTitle.ga': 'Vertalen',
  'fabric.editor.ai.config.item.translate.nestingParentTitlePostGA': 'Vertaal naar ...',
  'fabric.editor.ai.config.item.translate.norwegian': 'Noors',
  'fabric.editor.ai.config.item.translate.russian': 'Russisch',
  'fabric.editor.ai.config.item.translate.spanish': 'Spaans',
  'fabric.editor.ai.config.item.translate.swedish': 'Zweeds',
  'fabric.editor.ai.config.item.translateTo.chineseSimplified.description':
    'Vertaalt de tekst waar je mee bezig bent naar het Chinees (vereenvoudigd)',
  'fabric.editor.ai.config.item.translateTo.chineseSimplified.title': 'Vertalen naar het Chinees (vereenvoudigd)',
  'fabric.editor.ai.config.item.translateTo.chineseTraditional.description':
    'Vertaalt de tekst waar je mee bezig bent naar het Chinees (traditioneel)',
  'fabric.editor.ai.config.item.translateTo.chineseTraditional.title': 'Vertalen naar het Chinees (traditioneel)',
  'fabric.editor.ai.config.item.translateTo.czech.description':
    'Vertaalt de tekst waar je mee bezig bent naar het Tsjechisch',
  'fabric.editor.ai.config.item.translateTo.czech.title': 'Vertalen naar het Tsjechisch',
  'fabric.editor.ai.config.item.translateTo.danish.description':
    'Vertaalt de tekst waar je mee bezig bent naar het Deens',
  'fabric.editor.ai.config.item.translateTo.danish.title': 'Vertalen naar het Deens',
  'fabric.editor.ai.config.item.translateTo.dutch.description':
    'Vertaalt de tekst waar je mee bezig bent naar het Nederlands',
  'fabric.editor.ai.config.item.translateTo.dutch.title': 'Vertalen naar het Nederlands',
  'fabric.editor.ai.config.item.translateTo.english.description':
    'Vertaalt de tekst waar je mee bezig bent naar het Engels',
  'fabric.editor.ai.config.item.translateTo.english.title': 'Vertalen naar het Engels',
  'fabric.editor.ai.config.item.translateTo.finnish.description':
    'Vertaalt de tekst waar je mee bezig bent naar het Fins',
  'fabric.editor.ai.config.item.translateTo.finnish.title': 'Vertalen naar het Fins',
  'fabric.editor.ai.config.item.translateTo.french.description':
    'Vertaalt de tekst waar je mee bezig bent naar het Frans',
  'fabric.editor.ai.config.item.translateTo.french.title': 'Vertalen naar het Frans',
  'fabric.editor.ai.config.item.translateTo.german.description':
    'Vertaalt de tekst waar je mee bezig bent naar het Duits',
  'fabric.editor.ai.config.item.translateTo.german.title': 'Vertalen naar het Duits',
  'fabric.editor.ai.config.item.translateTo.hungarian.description':
    'Vertaalt de tekst waar je mee bezig bent naar het Hongaars',
  'fabric.editor.ai.config.item.translateTo.hungarian.title': 'Vertalen naar het Hongaars',
  'fabric.editor.ai.config.item.translateTo.italian.description':
    'Vertaalt de tekst waar je mee bezig bent naar het Italiaans',
  'fabric.editor.ai.config.item.translateTo.italian.title': 'Vertalen naar het Italiaans',
  'fabric.editor.ai.config.item.translateTo.japanese.description':
    'Vertaalt de tekst waar je mee bezig bent naar het Japans',
  'fabric.editor.ai.config.item.translateTo.japanese.title': 'Vertalen naar het Japans',
  'fabric.editor.ai.config.item.translateTo.korean.description':
    'Vertaalt de tekst waar je mee bezig bent naar het Koreaans',
  'fabric.editor.ai.config.item.translateTo.korean.title': 'Vertalen naar het Koreaans',
  'fabric.editor.ai.config.item.translateTo.norwegian.description':
    'Vertaalt de tekst waar je mee bezig bent naar het Noors',
  'fabric.editor.ai.config.item.translateTo.norwegian.title': 'Vertalen naar het Noors',
  'fabric.editor.ai.config.item.translateTo.polish.description':
    'Vertaalt de tekst waar je mee bezig bent naar het Pools',
  'fabric.editor.ai.config.item.translateTo.polish.title': 'Vertalen naar het Pools',
  'fabric.editor.ai.config.item.translateTo.portugueseBrazilian.description':
    'Vertaalt de tekst waar je mee bezig bent naar het Portugees (Braziliaans)',
  'fabric.editor.ai.config.item.translateTo.portugueseBrazilian.title': 'Vertalen naar het Portugees (Braziliaans)',
  'fabric.editor.ai.config.item.translateTo.russian.description':
    'Vertaalt de tekst waar je mee bezig bent naar het Russisch',
  'fabric.editor.ai.config.item.translateTo.russian.title': 'Vertalen naar het Russisch',
  'fabric.editor.ai.config.item.translateTo.spanish.description':
    'Vertaalt de tekst waar je mee bezig bent naar het Spaans',
  'fabric.editor.ai.config.item.translateTo.spanish.title': 'Naar het Spaans vertalen',
  'fabric.editor.ai.config.item.translateTo.swedish.description':
    'Vertaalt de tekst waar je mee bezig bent naar het Zweeds',
  'fabric.editor.ai.config.item.translateTo.swedish.title': 'Vertalen naar het Zweeds',
  'fabric.editor.ai.config.item.translateTo.thai.description': 'Vertaalt de tekst waar je mee bezig bent naar het Thai',
  'fabric.editor.ai.config.item.translateTo.thai.title': 'Vertalen naar het Thai',
  'fabric.editor.ai.config.item.translateTo.turkish.description':
    'Vertaalt de tekst waar je mee bezig bent naar het Turks',
  'fabric.editor.ai.config.item.translateTo.turkish.title': 'Vertalen naar het Turks',
  'fabric.editor.ai.config.item.translateTo.ukrainian.description':
    'Vertaalt de tekst waar je mee bezig bent naar het Oekraïens',
  'fabric.editor.ai.config.item.translateTo.ukrainian.title': 'Vertalen naar het Oekraïens',
  'fabric.editor.ai.config.item.translateTo.vietnamese.description':
    'Vertaalt de tekst waar je mee bezig bent naar het Vietnamees',
  'fabric.editor.ai.config.item.translateTo.vietnamese.title': 'Vertalen naar het Vietnamees',
  'fabric.editor.ai.confluence-prebuilt.confluenceChangeToneSelectionToolbarDropdownMenuTitle': 'Toon wijzigen',
  'fabric.editor.ai.confluence-prebuilt.confluenceRewriteSelectionToolbarDropdownMenuTitle': 'Herschrijven',
  'fabric.editor.ai.confluence-prebuilt.confluenceTranslateSelectionToolbarDropdownMenuTitle': 'Vertalen',
  'fabric.editor.ai.eventHub.fallbackSuggestedTitle': 'Paginatitel',
  'fabric.editor.ai.eventHub.fallbackSuggestedTitlePrefix': 'Pagina',
  'fabric.editor.ai.experience-application.documentInsertError':
    'Er gaat aan onze kant iets niet goed bij het invoeren van de reactie. Sluit het dialoogvenster en probeer het opnieuw.',
  'fabric.editor.ai.experience-application.error-boundary.markdownErrorMessage':
    'Er gaat aan onze kant iets niet goed bij het genereren van de voorbeeldweergave. Sluit het dialoogvenster en probeer het opnieuw.',
  'fabric.editor.ai.experience-application.rateLimitEnforced':
    'We hebben te veel aanvragen ontvangen voor Atlassian Intelligence (AI). Probeer het over een paar minuten opnieuw of ontdek meer informatie over <link>overmatig gebruik van AI</link>.',
  'fabric.editor.ai.experience-application.tokenLimitExceeded':
    'We konden geen reactie krijgen. Je prompt of reactie was boven de limiet voor deze aanvraag. Sluit het dialoogvenster en probeer het opnieuw.',
  'fabric.editor.ai.experience-application.unhandledErrorMessage':
    'Er gaat aan onze kant iets niet goed. Sluit het dialoogvenster en probeer het opnieuw.',
  'fabric.editor.ai.experience.apiError': 'We kregen geen reactie, probeer het opnieuw',
  'fabric.editor.ai.experience.aupViolationMessage':
    'Je prompt of inhoud voldoet mogelijk niet aan ons Acceptabel Gebruiksbeleid. Controleer deze allebei en raadpleeg ons <link>Acceptabel Gebruiksbeleid</link> indien nodig. Probeer een andere prompt of inhoud als het probleem zich blijft voordoen.',
  'fabric.editor.ai.experience.browseMore.agents': 'Agents zoeken',
  'fabric.editor.ai.experience.discardMessagePrompt': 'Wil je je prompt wissen?',
  'fabric.editor.ai.experience.discardMessageResponse': 'Wil je je reactie wissen?',
  'fabric.editor.ai.experience.elevateDisabledGenetateError': 'Vrij genereren is momenteel uitgeschakeld in Elevate',
  'fabric.editor.ai.experience.engagementBannerLinksText':
    '🚀 Je kunt nu links 🔗 naar Jira- en Confluence-inhoud in je prompts plakken.',
  'fabric.editor.ai.experience.footerRightText.agents': 'Mogelijk gemaakt door Rovo',
  'fabric.editor.ai.experience.generatingAiResponse': 'Genereren',
  'fabric.editor.ai.experience.hipaaContentError':
    'Atlassian Intelligence kon je aanvraag niet verwerken omdat je inhoud links bevat naar inhoud met een HIPAA-beperking. Verwijder deze links en probeer het opnieuw.',
  'fabric.editor.ai.experience.inputTooShortError':
    'De inhoud is te kort om samen te vatten. Voeg meer inhoud toe en probeer het dan nogmaals.',
  'fabric.editor.ai.experience.internalServerError':
    'Atlassian Intelligence (AI) reageert niet. Probeer het later opnieuw of <link>controleer de status van AI</link>.',
  'fabric.editor.ai.experience.labelRight.atlassianIntelligence': 'Atlassian Intelligence',
  'fabric.editor.ai.experience.labelRight.rovo': 'Rovo',
  'fabric.editor.ai.experience.loadingTitle': 'Genereren',
  'fabric.editor.ai.experience.messageTemplateAnalysingQuery': 'Analyseren: je vraag wordt bekeken.',
  'fabric.editor.ai.experience.messageTemplateContentSearch': 'Zoeken: een ogenblik geduld, we zoeken naar informatie.',
  'fabric.editor.ai.experience.messageTemplateNextBestTask': 'Zoeken: een ogenblik geduld, we doorzoeken Jira.',
  'fabric.editor.ai.experience.messageTemplatePageHydration': 'Zoeken: een ogenblik geduld, we doorzoeken de pagina.',
  'fabric.editor.ai.experience.noResultsSuggestion': 'Geen resultaten',
  'fabric.editor.ai.experience.responseTooSimilarMessage':
    'Op dit moment heeft Atlassian Intelligence geen suggesties. Probeer het gerust opnieuw met een andere prompt of inhoud.',
  'fabric.editor.ai.experience.showMoreButton': 'Meer tonen',
  'fabric.editor.ai.experience.suggestionGroupHeading.actions': 'Acties',
  'fabric.editor.ai.experience.suggestionGroupHeading.agents': 'Agents',
  'fabric.editor.ai.experience.suggestionGroupHeading.atlassianIntelligence': 'Atlassian Intelligence',
  'fabric.editor.ai.experience.suggestionGroupHeading.knowledgeSource': 'Kennisbron',
  'fabric.editor.ai.experience.suggestionGroupHeading.rovoAgents': 'Rovo-Agents',
  'fabric.editor.ai.experience.suggestionGroupHeading.rovoAgentsCount': 'Rovo-agents ({numberOfAgents})',
  'fabric.editor.ai.experience.suggestionGroupHeading.useRovoAgentsCount':
    'Een Rovo-Agent gebruiken ({numberOfAgents})',
  'fabric.editor.ai.experience.useGeneralAiKnowledgeLabel': 'Algemene kennis gebruiken',
  'fabric.editor.ai.experience.useRovoOrganisationKnowledgeLabel': 'Kennis binnen je organisatie gebruiken',
  'fabric.editor.ai.proactive.error.markdownErrorMessage':
    'Er gaat aan onze kant iets niet goed bij het genereren van de voorvertoning. Sluit het dialoogvenster en probeer het opnieuw.',
  'fabric.editor.ai.proactive.error.unhandledErrorMessage':
    'Er gaat aan onze kant iets niet goed. Sluit het dialoogvenster en probeer het opnieuw.',
  'fabric.editor.ai.proactive.preview.insertBelowProactiveRecommendation': 'Onderaan invoegen',
  'fabric.editor.ai.proactive.preview.replaceProactiveRecommendation': 'Vervangen',
  'fabric.editor.ai.screens.preview.convoAIBeta':
    "Aanvragen voor het genereren van inhoud die verwijzen naar URL's zijn in bèta.",
  'fabric.editor.ai.selectionToolbar.define.disabled.tooltip': 'Een term, acroniem of afkorting markeren',
  'fabric.editor.ai.selectionToolbar.define.title': 'Definiëren',
  'fabric.editor.ai.toolbar.askAI.title': 'Vragen aan AI',
  'fabric.editor.ai.toolbar.askRovoInputButton.label': 'Vraag Rovo ...',
  'fabric.editor.ai.toolbar.improveWriting.title': 'Schrijfstijl verbeteren',
  'fabric.editor.ai.toolbar.improveWriting.tooltip':
    'Geef Atlassian Intelligence de opdracht om de door jou geselecteerde tekst te verbeteren',
  'fabric.editor.ai.toolbar.simplifiedAI.title': 'AI',
  'fabric.editor.ai.toolbar.titleText': 'Atlassian Intelligence',
  'fabric.editor.ai.toolbar.tryAI.title': 'Probeer AI',
  'fabric.editor.ai.toolbar.tryAI.tooltip': 'Open Atlassian Intelligence',
  'fabric.editor.ai.toolbar.tryAI.tooltip.quickCommand': "Vraag AI {key}+'",
  'fabric.editor.alignCenter': 'Uitlijnen centreren',
  'fabric.editor.alignImageCenter': 'Uitlijnen centreren',
  'fabric.editor.alignImageLeft': 'Links uitlijnen',
  'fabric.editor.alignImageRight': 'Rechts uitlijnen',
  'fabric.editor.alignLeft': 'Links uitlijnen',
  'fabric.editor.alignRight': 'Rechts uitlijnen',
  'fabric.editor.alignTableCenter': 'Uitlijnen centreren',
  'fabric.editor.alignTableLeft': 'Links uitlijnen',
  'fabric.editor.alignment': 'Tekstuitlijning',
  'fabric.editor.altText': 'Alt-tekst',
  'fabric.editor.alttext.validation': 'Verwijder speciale tekens uit alt-tekst.',
  'fabric.editor.annotationToolbar': 'Aantekeningentaakbalk',
  'fabric.editor.backLink': 'Ga terug',
  'fabric.editor.backgroundColor': 'Achtergrondkleur',
  'fabric.editor.blockCardUnavailable': 'De inline-link zit in {node} en de weergave ervan kan niet gewijzigd worden',
  'fabric.editor.blockControlDelete': 'Verwijderen',
  'fabric.editor.blockControlDragHandleMove': 'Sleep om te verplaatsen',
  'fabric.editor.blockControlDragHandleRearrange': 'Sleep om te herschikken',
  'fabric.editor.blockControlInsert': 'Invoegen',
  'fabric.editor.blockControlMoveDown': 'Verplaats naar beneden',
  'fabric.editor.blockControlMoveLeft': 'Verplaatsen naar links',
  'fabric.editor.blockControlMoveRight': 'Verplaatsen naar rechts',
  'fabric.editor.blockControlMoveUp': 'Verplaats naar boven',
  'fabric.editor.blockControlMovedDown': 'Inhoud is naar beneden verplaatst',
  'fabric.editor.blockControlMovedUp': 'Inhoud is naar boven verplaatst',
  'fabric.editor.blockDescription': 'Meer informatie weergeven over een link, inclusief een samenvatting en acties',
  'fabric.editor.blockTitle': 'Kaart',
  'fabric.editor.blockquote': 'een citaat',
  'fabric.editor.blockquote.description': 'Voeg een citaat in',
  'fabric.editor.blockquote2': 'Citeren',
  'fabric.editor.bold': 'Vet',
  'fabric.editor.breakout.resizeCodeBlock': 'Grootte van codesnippet aanpassen',
  'fabric.editor.breakout.resizeElement': 'Grootte van element wijzigen',
  'fabric.editor.breakout.resizeExpand': 'Grootte van uitbreiding aanpassen',
  'fabric.editor.breakout.resizeLayout': 'Grootte van de lay-out wijzigen',
  'fabric.editor.breakoutFullWidthLabel': 'Volledige breedte',
  'fabric.editor.breakoutWideWidthLabel': 'Breed',
  'fabric.editor.bug': 'Bug',
  'fabric.editor.canNotSortTable': '⚠️ Je kan een tabel met samengevoegde cellen niet rangschikken',
  'fabric.editor.cancelButton': 'Annuleren',
  'fabric.editor.captionPlaceholder': 'Bijschrift toevoegen',
  'fabric.editor.captionPlaceholderWithDoubleClickPrompt':
    'Voeg een bijschrift toe - dubbelklik om een voorvertoning te zien',
  'fabric.editor.cardFloatingControls': 'Kaartopties',
  'fabric.editor.cellBackground': 'Celachtergrond',
  'fabric.editor.cellOptions': 'Celopties',
  'fabric.editor.checkUncheckActionItem': 'Actie-item in- of uitschakelen',
  'fabric.editor.clearAltTextEdit': 'Alt-tekst wissen',
  'fabric.editor.clearCells': '{0, plural, one {Cel leegmaken} other {Cellen leegmaken}}',
  'fabric.editor.clearFormatting': 'Wis opmaak',
  'fabric.editor.clearLink': 'Link wissen',
  'fabric.editor.clearLinkText': 'Tekst wissen',
  'fabric.editor.closeAltTextEdit': 'Terug',
  'fabric.editor.closeFindReplaceDialog': 'Sluiten',
  'fabric.editor.closeHelpDialog': 'Sluit helpdialoogvenster',
  'fabric.editor.code': 'Code',
  'fabric.editor.code.on': '{textFormattingOff}, code aan',
  'fabric.editor.codeBidiWarningLabel':
    'Bidirectionele tekens wijzigen de volgorde waarin de tekst wordt weergegeven. Dit kan worden gebruikt om schadelijke code te verdoezelen.',
  'fabric.editor.codeBlockCopyButton.copiedToClipboard': 'Gekopieerd!',
  'fabric.editor.codeBlockCopyButton.copyToClipboard': 'Kopieer als tekst',
  'fabric.editor.codeBlockWrapButton.unwrapCodeBlock': 'Wrap uitschakelen',
  'fabric.editor.codeBlockWrapButton.wrapCodeBlock': 'Wrap inschakelen',
  'fabric.editor.codeblock': 'Codefragment',
  'fabric.editor.codeblock.description': 'Code tonen met syntaxismarkering',
  'fabric.editor.collapseNode': 'Content inklappen',
  'fabric.editor.collapseTable': 'Tabel inklappen',
  'fabric.editor.colorPicker.menuLabel': 'Menu Kleurkiezer',
  'fabric.editor.columnDragHandle': 'Kolomopties',
  'fabric.editor.columnMovedLeft': 'Kolom naar links verplaatst naar {index} van {total}',
  'fabric.editor.columnMovedRight': 'Kolom naar rechts verplaatst naar {index} van {total}',
  'fabric.editor.columnSelected': 'Kolom {index} van {total} geselecteerd',
  'fabric.editor.columns': 'Lay-outs',
  'fabric.editor.columns.advanced.layout.description':
    '{numberOfColumns, plural, one {{numberOfColumns} gelijke kolom toevoegen} other {{numberOfColumns} gelijke kolommen toevoegen}}',
  'fabric.editor.columns.advanced.layout.single.description': 'Lay-out van één kolom invoegen',
  'fabric.editor.columns.description': 'Je pagina structureren met secties',
  'fabric.editor.columnsAreInserted':
    '{count, plural, one {Er is een kolom ingevoegd} other {Er zijn {count} kolommen ingevoegd}}',
  'fabric.editor.columnsAreRemoved':
    '{count, plural, one {De kolom is verwijderd} other {{count} kolommen zijn verwijderd}}',
  'fabric.editor.configFailedToLoad': 'Fout bij het laden',
  'fabric.editor.configPanel.cancel': 'Annuleren',
  'fabric.editor.configPanel.close': 'Sluiten',
  'fabric.editor.configPanel.customSelect.createOption': 'Aanmaken',
  'fabric.editor.configPanel.dateRange.custom.from': 'Vanaf',
  'fabric.editor.configPanel.dateRange.custom.to': 'tot',
  'fabric.editor.configPanel.dateRange.grouping.collapse': 'Inklappen',
  'fabric.editor.configPanel.dateRange.grouping.expand': 'Uitvouwen',
  'fabric.editor.configPanel.dateRange.option.custom': 'Aangepast',
  'fabric.editor.configPanel.documentation': 'Documentatie',
  'fabric.editor.configPanel.errorBoundary.note':
    'We hebben het team op de hoogte gebracht. Je kunt de pagina nog bewerken en publiceren. Of bekijk de foutconsole voor meer informatie.',
  'fabric.editor.configPanel.errorBoundary.title': 'Er is iets misgegaan.',
  'fabric.editor.configPanel.fieldTypeError.isMultipleAndRadio': 'Kan isMultiple niet combineren met stijl: radio',
  'fabric.editor.configPanel.formType.addField': 'Veld toevoegen',
  'fabric.editor.configPanel.formType.removeField': 'Veld verwijderen',
  'fabric.editor.configPanel.help': 'Hulp nodig?',
  'fabric.editor.configPanel.invalid': 'Ongeldig veld',
  'fabric.editor.configPanel.required': 'Verplicht veld',
  'fabric.editor.configPanel.submit': 'Verzenden',
  'fabric.editor.contextPanel.panelLabel': 'Contextvenster',
  'fabric.editor.copiedToClipboard': 'Gekopieerd!',
  'fabric.editor.copyToClipboard': 'Kopiëren',
  'fabric.editor.cornerControl': 'Tabel markeren',
  'fabric.editor.createComment': 'Opmerking maken',
  'fabric.editor.createCommentDisabled':
    'Je kunt alleen opmerkingen plaatsen bij tekst, kopteksten, emoticons, datums, vermeldingen, links en statussen.',
  'fabric.editor.createCommentInvalid': 'Je kunt alleen opmerkingen plaatsen bij tekst en koppen',
  'fabric.editor.createCommentOnInlineNodeSpotlight.action': 'Begrepen',
  'fabric.editor.createCommentOnInlineNodeSpotlight.body':
    'Je kunt nu opmerkingen achterlaten op inline-elementen zoals links, datums, statussen en vermeldingen.',
  'fabric.editor.customPanel': 'Aangepast paneel',
  'fabric.editor.customPanel.description': 'Voeg een notitie toe met een emoji en een gekleurde achtergrond',
  'fabric.editor.datasource.assetsObjects.description':
    'Voeg objecten van Assets in Jira Service Management in met behulp van zoeken en filteren',
  'fabric.editor.datasource.assetsObjectsGeneralAvailability': 'Assets',
  'fabric.editor.datasource.confluenceSearch': 'Confluence-lijst invoegen',
  'fabric.editor.datasource.confluenceSearch.description':
    'Voeg lijst met zoekresultaten in vanuit Confluence met verbeterde zoekfunctie, filteren en configuratie.',
  'fabric.editor.datasource.jiraIssue': 'Jira-issues',
  'fabric.editor.datasource.jiraIssue.description':
    'Voeg Jira-issues in vanuit Jira Cloud met verbeterde zoekfunctie, filteren en configuratie.',
  'fabric.editor.datasource.jiraIssue.description.issue-term-refresh':
    'Voeg Jira-werkitems in vanuit Jira Cloud met verbeterde zoekfunctie, filteren en configuratie.',
  'fabric.editor.datasource.jiraIssue.issue-term-refresh': 'Jira-werkitems',
  'fabric.editor.datasourceAppearanceTitle': 'Lijst',
  'fabric.editor.datasourceTitle': 'Zoekopdracht bewerken',
  'fabric.editor.date': 'Datum',
  'fabric.editor.date.description': 'Een datum toevoegen via een agenda',
  'fabric.editor.datePickerOpenedAlert': 'Pop-up met datumbewerker is geopend. Druk op Tab om de pop-up te gebruiken',
  'fabric.editor.decision': 'Beslissing',
  'fabric.editor.decision.description': 'Beslissingen vastleggen zodat deze eenvoudig te traceren zijn',
  'fabric.editor.decisionPlaceholder': 'Beslissing toevoegen...',
  'fabric.editor.decreaseElementSize': 'Elementgrootte verkleinen',
  'fabric.editor.decreaseSize': 'Grootte van tabel of media verkleinen',
  'fabric.editor.defaultAltText': 'Document',
  'fabric.editor.delete': 'Verwijderen',
  'fabric.editor.description': 'Omschrijving',
  'fabric.editor.displayBlock': 'Kaart weergeven',
  'fabric.editor.displayEmbed': 'Ingesloten weergeven',
  'fabric.editor.displayInline': 'Inline weergeven',
  'fabric.editor.displayLink': 'Als tekst weergeven',
  'fabric.editor.displayOptionUnavailableInParentNode': 'Deze weergaveoptie is niet beschikbaar binnen {node}.',
  'fabric.editor.displayText': 'Tekst om te tonen',
  'fabric.editor.distributeColumns': 'Kolommen verdelen',
  'fabric.editor.dropPlaceholderLabel': 'Document',
  'fabric.editor.ecombedDescription': 'Een interactieve preview van een link weergeven',
  'fabric.editor.edit': 'Bewerken',
  'fabric.editor.edit.datasource': 'Zoekopdracht bewerken',
  'fabric.editor.edit.searchInput': 'Een link toevoegen',
  'fabric.editor.editAccessTitle': 'Je hebt bewerkrechten nodig',
  'fabric.editor.editAltText': 'Alt-tekst bewerken',
  'fabric.editor.editDatasourceStandalone': 'Bewerken',
  'fabric.editor.editDatasourceStandaloneTooltip': 'Zoekopdracht bewerken',
  'fabric.editor.editDateText': 'Bewerkingsdatum',
  'fabric.editor.editDropdownEditDatasourceTitle': 'Zoekopdracht bewerken',
  'fabric.editor.editDropdownEditLinkTitle': 'Link bewerken',
  'fabric.editor.editDropdownExpandIconLabel': 'Vervolgkeuzemenu uitklappen',
  'fabric.editor.editDropdownTriggerTitle': 'Bewerken',
  'fabric.editor.editLink': 'Link bewerken',
  'fabric.editor.editMode.inviteToEditButton.title': 'Uitnodigen om te bewerken',
  'fabric.editor.editStatusColor': 'Statuskleur bewerken',
  'fabric.editor.editStatusText': 'Status bewerken',
  'fabric.editor.editableContentLabel': 'Aanpasbare inhoud',
  'fabric.editor.editorHelp': 'Editor-help',
  'fabric.editor.editors': 'Editors',
  'fabric.editor.elementBrowser.help': 'Help',
  'fabric.editor.elementInsertSidePanel.title': 'Invoegen',
  'fabric.editor.elementbrowser.categorylist.category-admin': 'Beheer',
  'fabric.editor.elementbrowser.categorylist.category-ai': 'Atlassian Intelligence',
  'fabric.editor.elementbrowser.categorylist.category-all': 'Alle',
  'fabric.editor.elementbrowser.categorylist.category-communication': 'Communicatie',
  'fabric.editor.elementbrowser.categorylist.category-confluence-content': 'Confluence content',
  'fabric.editor.elementbrowser.categorylist.category-development': 'Ontwikkeling',
  'fabric.editor.elementbrowser.categorylist.category-external-content': 'Externe content',
  'fabric.editor.elementbrowser.categorylist.category-formatting': 'Opmaak',
  'fabric.editor.elementbrowser.categorylist.category-media': 'Media',
  'fabric.editor.elementbrowser.categorylist.category-navigation': 'Navigatie',
  'fabric.editor.elementbrowser.categorylist.category-reporting': 'Rapportage',
  'fabric.editor.elementbrowser.categorylist.category-visuals': 'Beeldmateriaal en afbeeldingen',
  'fabric.editor.elementbrowser.featured.whiteboard.description':
    'Gebruik een whiteboard om visuele elementen toe te voegen aan je pagina',
  'fabric.editor.elementbrowser.search.empty-state.heading': 'Er komt niets met je zoekopdracht overeen',
  'fabric.editor.elementbrowser.search.empty-state.sub-heading':
    'Probeer met een andere term te zoeken of ontdek nieuwe apps voor Atlassian-producten.',
  'fabric.editor.elementbrowser.search.empty-state.sub-heading.link': 'Atlassian Marketplace ontdekken',
  'fabric.editor.elementbrowser.searchbar.assistive.text.default':
    '{count, plural, =0 {Er komt niets overeen met je zoekopdracht.} one {{count} suggestie is standaard beschikbaar.} other {{count} suggesties zijn standaard beschikbaar.}}',
  'fabric.editor.elementbrowser.searchbar.assistive.text.result':
    '{count, plural, =0 {Er komt niets overeen met je zoekopdracht.} one {{count} suggestie beschikbaar voor getypte tekst.} other {{count} suggesties beschikbaar voor getypte tekst.}}',
  'fabric.editor.elementbrowser.searchbar.elementAfterInput': 'Invoeren',
  'fabric.editor.elementbrowser.searchbar.placeholder': 'Zoeken',
  'fabric.editor.elementbrowser.sidebar.heading': 'Bladeren',
  'fabric.editor.embedTitle': 'Insluiten',
  'fabric.editor.emoji': 'Emoji',
  'fabric.editor.emoji.description': "Emoji's gebruiken om ideeën 🎉 en emoties 😄 te delen",
  'fabric.editor.emptyLink': 'Voer een link in.',
  'fabric.editor.emptySearchResults': 'We konden geen resultaten vinden.',
  'fabric.editor.emptySearchResultsSuggestion': 'Selecteer {buttonName} om bijlagen te bekijken.',
  'fabric.editor.epic': 'Epic',
  'fabric.editor.error': 'Fout',
  'fabric.editor.errorPanel': 'Foutpaneel',
  'fabric.editor.errorPanel.description': 'Bijschrift voor fouten maken in een gekleurd paneel',
  'fabric.editor.expand': 'Uitvouwen',
  'fabric.editor.expand.description': 'Uitvouwen toepassen',
  'fabric.editor.expandAriaLabel': 'Geef deze uitbreiding een titel',
  'fabric.editor.expandDefaultTitle': 'Klik hier om uit te vouwen...',
  'fabric.editor.expandNode': 'Content uitbreiden',
  'fabric.editor.expandPlaceholder': 'Geef deze uitvouwing een naam...',
  'fabric.editor.extension.confirmDeleteLinkedModalMessage':
    'Als je {nodeName} verwijdert, worden alle koppelingen ernaar verbroken.',
  'fabric.editor.extension.confirmDeleteLinkedModalMessagePrefix': 'Bezig met verwijderen van',
  'fabric.editor.extension.confirmDeleteLinkedModalOKButton': 'Verwijderen',
  'fabric.editor.extension.deleteElementTitle': 'Element verwijderen',
  'fabric.editor.extension.sourceNoTitledName': 'dit element',
  'fabric.editor.extensions.config-panel.save-indicator': 'Alle wijzigingen worden altijd automatisch opgeslagen',
  'fabric.editor.externalExtensionsHeading': 'Apps',
  'fabric.editor.externalMediaFile': 'Extern mediabestand',
  'fabric.editor.failed_to_upload': 'Kan niet worden geüpload',
  'fabric.editor.feedbackDialog': 'Feedback geven',
  'fabric.editor.feedbackDialog.description': 'Vertel ons wat je van de cloudeditor vindt',
  'fabric.editor.find': 'Zoeken',
  'fabric.editor.findNext': 'Volgende zoeken',
  'fabric.editor.findPrevious': 'Vorige zoeken',
  'fabric.editor.findReplaceToolbarButton': 'Zoeken en vervangen',
  'fabric.editor.fiveColumns': 'Lay-out van 5 kolommen',
  'fabric.editor.floatingToolbar.confirmModalCancel': 'Annuleren',
  'fabric.editor.floatingToolbar.confirmModalCheckboxLabel': 'Ook gekoppelde elementen verwijderen',
  'fabric.editor.floatingToolbar.confirmModalConnectedUnit':
    '{amount, plural, =0 {{name}} one {{name} (+1 gekoppeld element)} other {{name} (+{amount,number} gekoppelde elementen)}}',
  'fabric.editor.floatingToolbar.confirmModalHeading': 'Weet je het zeker?',
  'fabric.editor.floatingToolbar.confirmModalOK': 'Oké',
  'fabric.editor.floatingToolbar.floatingToolbarAnnouncer': 'Bediening voor zwevende werkbalk is geopend',
  'fabric.editor.floatingToolbar.floatingToolbarAriaLabel': 'Zwevende werkbalk',
  'fabric.editor.floatingToolbar.floatingToolbarRadioGroupAriaLabel': 'Lay-outopties',
  'fabric.editor.floatingToolbar.scrollLeft': 'Scrol naar links',
  'fabric.editor.floatingToolbar.scrollRight': 'Scrol naar rechts',
  'fabric.editor.focusTableResizeHandle': 'Knop om grootte van focustabel te wijzigen',
  'fabric.editor.fourColumns': 'Lay-out van 4 kolommen',
  'fabric.editor.headerColumn': 'Header-kolom',
  'fabric.editor.headerRow': 'Header-rij',
  'fabric.editor.heading1': 'Koptekst 1',
  'fabric.editor.heading1Description': 'Gebruik dit voor een kop op het hoogste niveau',
  'fabric.editor.heading2': 'Koptekst 2',
  'fabric.editor.heading2Description': 'Gebruik dit voor belangrijke gedeelten',
  'fabric.editor.heading3': 'Koptekst 3',
  'fabric.editor.heading3Description': 'Gebruik dit voor subsecties en groepskoppen',
  'fabric.editor.heading4': 'Koptekst 4',
  'fabric.editor.heading4Description': 'Gebruik dit voor diepe koppen',
  'fabric.editor.heading5': 'Koptekst 5',
  'fabric.editor.heading5Description': 'Gebruik dit voor het groeperen van lijstitems',
  'fabric.editor.heading6': 'Koptekst 6',
  'fabric.editor.heading6Description': 'Gebruik dit voor koppen op laag niveau',
  'fabric.editor.headingLink.ascOrderLabel': 'Rangschik kolom van Z tot A',
  'fabric.editor.headingLink.descOrderLabel': 'Sortering wissen',
  'fabric.editor.headingLink.hyperlinkIconBlogLabel': 'Blog',
  'fabric.editor.headingLink.hyperlinkIconBugLabel': 'Bug',
  'fabric.editor.headingLink.hyperlinkIconIssueLabel': 'Issue',
  'fabric.editor.headingLink.hyperlinkIconIssueLabel.issue-term-refresh': 'Werkitem',
  'fabric.editor.headingLink.hyperlinkIconPageLabel': 'Pagina',
  'fabric.editor.headingLink.hyperlinkIconStoryLabel': 'Story',
  'fabric.editor.headingLink.hyperlinkIconTaskLabel': 'Taak',
  'fabric.editor.headingLink.invalidLabel': '⚠️ Je kan een tabel met samengevoegde cellen niet rangschikken',
  'fabric.editor.headingLink.noOrderLabel': 'Rangschik kolom van A tot Z',
  'fabric.editor.help': 'Help',
  'fabric.editor.help.description': 'Blader door alle opties voor sneltoetsen en markdowns',
  'fabric.editor.helpDialogTips': 'Klik op {keyMap} om dit dialoogvenster snel te openen',
  'fabric.editor.highlight': 'Kleur markeren',
  'fabric.editor.highlightColor': 'Kleurenpalet voor markeringen in- en uitschakelen',
  'fabric.editor.highlightFloatingToolbar': 'Highlight',
  'fabric.editor.horizontalRule': 'Scheidingslijn',
  'fabric.editor.horizontalRule.description': 'Inhoud scheiden met een horizontale lijn',
  'fabric.editor.hyperlink.linkVisibleLabel': 'Link plakken of zoeken',
  'fabric.editor.hyperlink.searchLinkAriaDescription': 'Suggesties verschijnen hieronder zodra je in het veld typt',
  'fabric.editor.hyperlink.searchLinkResults':
    '{count, plural, =0 {geen resultaten gevonden} one {{count,number} resultaat gevonden} other {{count,number} resultaten gevonden}}',
  'fabric.editor.hyperlink.textVisibleLabel': 'Tekst weergeven (optioneel)',
  'fabric.editor.hyperlinkToolbarPlaceholder': 'Link plakken of zoeken',
  'fabric.editor.image': 'Afbeelding',
  'fabric.editor.image.fullWidthLabel': 'Volledige breedte',
  'fabric.editor.imageBorderBold': 'Vet',
  'fabric.editor.imageBorderColor': 'Kleur',
  'fabric.editor.imageBorderColor.dropdownAriaLabel': 'Opties voor rand van de afbeelding, vervolgkeuzelijst met kleur',
  'fabric.editor.imageBorderMedium': 'Medium',
  'fabric.editor.imageBorderOptions': 'Kaderopties',
  'fabric.editor.imageBorderSize': 'Grootte',
  'fabric.editor.imageBorderSize.dropdownAriaLabel':
    'Opties voor rand van de afbeelding, vervolgkeuzelijst voor grootte',
  'fabric.editor.imageBorderSubtle': 'Subtiel',
  'fabric.editor.improvement': 'Verbetering',
  'fabric.editor.increaseElementSize': 'Elementgrootte vergroten',
  'fabric.editor.increaseSize': 'Grootte van tabel of media vergroten',
  'fabric.editor.indent': 'Inspringen',
  'fabric.editor.info': 'Informatie',
  'fabric.editor.infoPanel': 'Infopaneel',
  'fabric.editor.infoPanel.description': 'Informatie markeren in een gekleurd paneel',
  'fabric.editor.inlineConfigureLink': 'Link configureren',
  'fabric.editor.inlineDescription': 'Link als inline-tekst weergeven',
  'fabric.editor.inlineGoToLink': 'Ga naar link',
  'fabric.editor.inlineOverlay': 'Configureren',
  'fabric.editor.inlineTitle': 'Inline',
  'fabric.editor.inputQueryAssistiveTxt':
    'Wanneer resultaten voor automatisch aanvullen beschikbaar zijn, kun je de pijlen naar boven en beneden gebruiken om ze te bekijken en Enter om ze te selecteren. Touch-apparaatgebruikers verkennen door middel van aanraking of met veegbewegingen.',
  'fabric.editor.insertColumn': 'Kolom rechts invoegen',
  'fabric.editor.insertColumnDrag': 'Voeg kolom in',
  'fabric.editor.insertMenu': 'Elementen invoegen',
  'fabric.editor.insertRightRail.close': 'Sluiten',
  'fabric.editor.insertRightRail.title': 'Invoegen',
  'fabric.editor.insertRow': 'Rij onder invoegen',
  'fabric.editor.insertRowDrag': 'Voeg rij in',
  'fabric.editor.insertTableColumn': 'Tabelkolom invoegen',
  'fabric.editor.insertTableRow': 'Tabelrij invoegen',
  'fabric.editor.invalidDateError': 'Voer een geldige datum in',
  'fabric.editor.invalidLink': 'Voer een geldige link in.',
  'fabric.editor.inviteItem.title':
    '{userRole, select, admin {Nodig teamgenoten uit voor {productName}} trusted {Nodig teamgenoten uit voor {productName}} other {Voeg teamgenoten toe aan {productName}}}',
  'fabric.editor.italic': 'Cursief',
  'fabric.editor.keyboardShortcuts': 'Sneltoetsen',
  'fabric.editor.layout.columnOption': '{count, plural, one {Kolom} other {{count} kolommen}}',
  'fabric.editor.layout.controls.placeholder': '/ om iets in te voegen',
  'fabric.editor.layout.placeholder': 'Inhoud toevoegen',
  'fabric.editor.layout.resizeLayout': 'Formaat van de lay-out wijzigen',
  'fabric.editor.layoutFixedWidth': 'Terug naar midden',
  'fabric.editor.layoutFullWidth': 'Op volledige breedte weergeven',
  'fabric.editor.layoutStateFixedWidth': 'Gecentreerd',
  'fabric.editor.layoutStateFullWidth': 'Volledige breedte',
  'fabric.editor.layoutStateWide': 'Breed',
  'fabric.editor.layoutWide': 'Brede weergave',
  'fabric.editor.leftSidebar': 'Lay-out van linkerzijbalk',
  'fabric.editor.link': 'Link',
  'fabric.editor.link.description': 'Een link invoegen',
  'fabric.editor.linkAddress': 'Linkadres',
  'fabric.editor.linkPlaceholder': 'Plak link',
  'fabric.editor.lists': 'Lijsten',
  'fabric.editor.listsFormat': 'Lijstopmaak',
  'fabric.editor.lockColumns': 'Vaste kolombreedtes',
  'fabric.editor.longEmptyNodePlaceholderText': 'Typ / om elementen in te voegen',
  'fabric.editor.markdown': 'Markdown',
  'fabric.editor.matchCase': 'Overeenkomende zaak',
  'fabric.editor.media.DefaultMediaWidthDecreased':
    '{newMediaWidth, plural, one {Mediabreedte verminderd tot {newMediaWidth,number} pixel.} other {Mediabreedte verminderd tot {newMediaWidth,number} pixels.}}',
  'fabric.editor.media.DefaultMediaWidthIncreased':
    '{newMediaWidth, plural, one {Mediabreedte verhoogd tot {newMediaWidth,number} pixel.} other {Mediabreedte verhoogd tot {newMediaWidth,number} pixels.}}',
  'fabric.editor.media.MediaWidthIsMin': 'Media verkleind tot het minimale formaat',
  'fabric.editor.media.insert.cancel': 'Annuleren',
  'fabric.editor.media.insert.fileTabTitle': 'Bestand',
  'fabric.editor.media.insert.fromUrlErrorMessage':
    'We kunnen deze afbeeldingslink helaas niet toevoegen. Download de afbeelding en sleep deze vervolgens op de pagina.',
  'fabric.editor.media.insert.fromUrlWarning':
    'Deze afbeelding is mogelijk niet zichtbaar voor anderen vanwege bronbeperkingen. Overweeg om in plaats daarvan het bestand te uploaden.',
  'fabric.editor.media.insert.insert': 'Invoegen',
  'fabric.editor.media.insert.invalidUrlErrorMessage': 'Ongeldige link',
  'fabric.editor.media.insert.linkTabTitle': 'Link',
  'fabric.editor.media.insert.loadPreview': 'Voorvertoning laden',
  'fabric.editor.media.insert.localFileErrorMessage': 'Dit bestand kon niet geüpload worden.',
  'fabric.editor.media.insert.localFileNetworkErrorMessage':
    'Fout bij uploaden bestand. Controleer het bestandspad of netwerk.',
  'fabric.editor.media.insert.mediaAlt': 'Voorvertoning van geüploade afbeelding of videobestand',
  'fabric.editor.media.insert.mediaPickerPopupAriaLabel': 'Mediakiezer',
  'fabric.editor.media.insert.pasteLinkToUpload': 'Plak de link om te uploaden',
  'fabric.editor.media.insert.upload': 'Uploaden',
  'fabric.editor.media.pixelEntry.MediaWidthIsMax': 'Media vergroot tot het maximale formaat',
  'fabric.editor.media.pixelEntry.ResizeOption': 'Formaat wijzigen',
  'fabric.editor.media.pixelEntry.closePixelEntry': 'Sluiten',
  'fabric.editor.media.pixelEntry.inputHeightAriaLabel': 'hoogte-invoer',
  'fabric.editor.media.pixelEntry.inputHeightTooltip': 'Hoogte',
  'fabric.editor.media.pixelEntry.inputWidthAriaLabel': 'Maximale breedte {maxWidth} px',
  'fabric.editor.media.pixelEntry.inputWidthLabel': 'Breedte',
  'fabric.editor.media.pixelEntry.inputWidthTooltip': 'Maximale breedte {maxWidth} px',
  'fabric.editor.media.pixelEntry.migrationButtonText': 'Omzetten naar pixels',
  'fabric.editor.media.pixelEntry.migrationButtonTooltip': 'Migreren van percentage naar vaste pixelgrootte',
  'fabric.editor.media.pixelEntry.submitButtonText': 'Verzenden',
  'fabric.editor.media.pixelEntry.validationFailedMessage': 'Het valideren van de breedte is mislukt',
  'fabric.editor.mediaAddLink': 'Link toevoegen',
  'fabric.editor.mediaFiles': 'Afbeelding, video of bestand',
  'fabric.editor.mediaFiles.description': 'Afbeeldingen en andere bestanden aan je pagina toevoegen',
  'fabric.editor.mediaGroupDeleteLabel': 'Verwijderen',
  'fabric.editor.media_change_mediainline_caption_warn': 'Inline (bijschrift wordt verwijderd)',
  'fabric.editor.media_change_mediainline_default': 'Inline',
  'fabric.editor.media_change_mediasingle': 'Oorspronkelijke grootte',
  'fabric.editor.mention': 'Vermelding',
  'fabric.editor.mention.description': 'Iemand noemen om diegene een melding te sturen',
  'fabric.editor.mentionNode.label': 'Getagde gebruiker',
  'fabric.editor.mentionsAddLabel': 'pictogram toevoegen',
  'fabric.editor.mentionsIconLabel': 'Vermelding',
  'fabric.editor.mergeCells': 'Voeg cellen samen',
  'fabric.editor.moreFormatting': 'Meer opmaak',
  'fabric.editor.moveColumnLeft':
    '{0, plural, one {Kolom naar links verplaatsen} other {Kolommen naar links verplaatsen}}',
  'fabric.editor.moveColumnRight':
    '{0, plural, one {Kolom naar rechts verplaatsen} other {Kolommen naar rechts verplaatsen}}',
  'fabric.editor.moveDownDown':
    '{0, plural, one {Rij naar beneden verplaatsen} other {Rijen naar beneden verplaatsen}}',
  'fabric.editor.moveRowUp': '{0, plural, one {Rij naar boven verplaatsen} other {Rijen naar boven verplaatsen}}',
  'fabric.editor.navigate.toolbar.askAI': 'Vragen aan AI',
  'fabric.editor.navigate.toolbar.editor': 'Navigeer naar werkbalk editor',
  'fabric.editor.navigate.toolbar.floating': 'Navigeer naar zwevende werkbalk',
  'fabric.editor.noResultsFound': 'Geen resultaten',
  'fabric.editor.noSearchResults': 'Geen zoekresultaten',
  'fabric.editor.normal': 'Normale tekst',
  'fabric.editor.note': 'Notitie',
  'fabric.editor.notePanel': 'Notitiepaneel',
  'fabric.editor.notePanel.description': 'Een opmerking toevoegen in een gekleurd paneel',
  'fabric.editor.numberedColumn': 'Genummerde kolom',
  'fabric.editor.off': '{formattingType} uit',
  'fabric.editor.on': '{formattingType} aan',
  'fabric.editor.openButtonTitle': 'Openen',
  'fabric.editor.openCellOptions': 'Celopties openen',
  'fabric.editor.openLink': 'Link openen in een nieuw tabblad',
  'fabric.editor.orderedList': 'Genummerde lijst',
  'fabric.editor.orderedList.description': 'Een gesorteerde lijst maken',
  'fabric.editor.other': 'Andere ...',
  'fabric.editor.outdent': 'Inspringen verkleinen',
  'fabric.editor.overflowMenuViewMore': 'Meer bekijken',
  'fabric.editor.pageActionsLabel': 'Pagina-acties',
  'fabric.editor.panel': 'Paneel',
  'fabric.editor.panel.backgroundColor': 'Achtergrondkleur',
  'fabric.editor.panel.custom': 'Aangepast',
  'fabric.editor.panel.emoji': 'Emoticon toevoegen',
  'fabric.editor.panel.panelsGroup': 'Typen panelen',
  'fabric.editor.pasteOptions': 'Opties voor plakken',
  'fabric.editor.pastePlainText': 'Plak als platte tekst',
  'fabric.editor.placeholderAltText': 'Beschrijf deze afbeelding met alt-tekst',
  'fabric.editor.placeholderText': 'Plaatsaanduidingstekst',
  'fabric.editor.placeholderText.description': 'Voeg een tekstplaatshouder in de pagina in',
  'fabric.editor.placeholderTextPlaceholder': 'Voeg plaatsaanduidingstekst toe',
  'fabric.editor.plainText': 'Tekst zonder opmaak gebruiken',
  'fabric.editor.preferencesLink': 'Voorkeuren voor links',
  'fabric.editor.quickInsert': 'Snel invoegen',
  'fabric.editor.recordLoomShortTitle': 'Opnemen',
  'fabric.editor.recordVideo': 'Een Loom-video opnemen',
  'fabric.editor.recordVideo.description': 'Neem je scherm en je ideeën op en deel ze',
  'fabric.editor.redo': 'Pas opnieuw toe',
  'fabric.editor.remove': 'Verwijderen',
  'fabric.editor.removeColumns': '{0, plural, one {Kolom verwijderen} other {Kolommen verwijderen}}',
  'fabric.editor.removeEmoji': 'Emoji verwijderen',
  'fabric.editor.removeImageBorder': 'Kader verwijderen',
  'fabric.editor.removeRows': '{0, plural, one {Rij verwijderen} other {Rijen verwijderen}}',
  'fabric.editor.replace': 'Vervangen',
  'fabric.editor.replaceAll': 'Alles vervangen',
  'fabric.editor.replaceSuccess':
    '{numberOfMatches, plural, one {{numberOfMatches,number} match vervangen} other {{numberOfMatches,number} matches vervangen}}',
  'fabric.editor.replaceWith': 'Vervangen met',
  'fabric.editor.requestToEdit': 'Aanvraag om te bewerken',
  'fabric.editor.requestToEditDescription': 'Als je toegang aanvraagt, ontvangt de pagina-eigenaar een melding.',
  'fabric.editor.requestToEditDismiss': 'Negeren',
  'fabric.editor.resizeHandle': 'Grootte van handvat wijzigen',
  'fabric.editor.resultsCount': '{selectedMatchPosition} van {totalResultsCount}',
  'fabric.editor.richText': 'Tekst met opmaak gebruiken',
  'fabric.editor.rightSidebar': 'Lay-out van rechterzijbalk',
  'fabric.editor.rowControl': 'Rij markeren',
  'fabric.editor.rowDragHandle': 'Rij-opties',
  'fabric.editor.rowMovedDown': 'Rij naar beneden verplaatst naar {index} van {total}',
  'fabric.editor.rowMovedUp': 'Rij naar boven verplaatst naar {index} van {total}',
  'fabric.editor.rowSelected': 'Rij {index} van {total} geselecteerd',
  'fabric.editor.rowsAreInserted':
    '{count, plural, one {Er is een rij ingevoegd} other {Er zijn {count} rijen ingevoegd}}',
  'fabric.editor.rowsAreRemoved': '{count, plural, one {De rij is verwijderd} other {{count} rijen zijn verwijderd}}',
  'fabric.editor.saveButton': 'Opslaan',
  'fabric.editor.searchResults':
    '{itemsLength, plural, one {{itemsLength,number} zoekresultaat beschikbaar. Gebruik de pijltoetsen omhoog en omlaag om tussen de opties te navigeren. Druk op Enter om een optie te selecteren.} other {{itemsLength,number} zoekresultaten beschikbaar. Gebruik de pijltoetsen omhoog en omlaag om tussen de opties te navigeren. Druk op Enter om een optie te selecteren.}}',
  'fabric.editor.selectColumnResize': 'Aanpassing grootte van kolom selecteren',
  'fabric.editor.selectLanguage': 'Selecteer taal',
  'fabric.editor.selectTableColumn': 'Selecteer tabelkolom',
  'fabric.editor.selectTableRow': 'Selecteer tabelrij',
  'fabric.editor.selectionExtensionDropdownButtonLabel': 'App selecteren',
  'fabric.editor.settingsLinks': 'Ga naar koppelingsvoorkeuren',
  'fabric.editor.shortEmptyNodePlaceholderText': '/ om iets in te voegen',
  'fabric.editor.shortcut': 'Sneltoets voor tekst',
  'fabric.editor.single': 'Lay-out van één kolom',
  'fabric.editor.singleColumns': 'Lay-out van 1 kolom',
  'fabric.editor.sortColumnASC': 'Rangschik kolom van A → Z',
  'fabric.editor.sortColumnDESC': 'Rangschik kolom van Z → A',
  'fabric.editor.sortColumnDecreasing': 'Aflopend sorteren',
  'fabric.editor.sortColumnIncreasing': 'Oplopend sorteren',
  'fabric.editor.splitCell': 'Deel cel op',
  'fabric.editor.status': 'Status',
  'fabric.editor.status.description': 'Een aangepast statuslabel toevoegen',
  'fabric.editor.statusEditorLabel': 'Statuseditor',
  'fabric.editor.statusPickerOpenedAlert': 'Pop-up met statusbewerker is geopend. Druk op Tab om de pop-up te openen',
  'fabric.editor.statusPlaceholder': 'Status instellen',
  'fabric.editor.story': 'Story',
  'fabric.editor.strike': 'Doorgehaald',
  'fabric.editor.subTask': 'Subtaak',
  'fabric.editor.subscript': 'Subscript',
  'fabric.editor.subscript.off.superscript.on': 'Subscript uit, superscript aan',
  'fabric.editor.success': 'Gelukt',
  'fabric.editor.successPanel': 'Succespaneel',
  'fabric.editor.successPanel.description': 'Tips toevoegen in een gekleurd paneel',
  'fabric.editor.superscript': 'Superscript',
  'fabric.editor.superscript.off.subscript.on': 'Superscript uit, subscript aan',
  'fabric.editor.supportAltText':
    'Alt-tekst is handig voor mensen die gebruikmaken van schermlezers vanwege visuele beperkingen.',
  'fabric.editor.table': 'Tabel',
  'fabric.editor.table.description': 'Een tabel invoegen',
  'fabric.editor.tableAlignmentOptions': 'Opties voor uitlijnen',
  'fabric.editor.tableFullWidthLabel': 'Volledige breedte',
  'fabric.editor.tableHeader.sorting.asc': 'Oplopende sortering toegepast',
  'fabric.editor.tableHeader.sorting.default': 'Sorteer de kolom',
  'fabric.editor.tableHeader.sorting.desc': 'Aflopende sortering toegepast',
  'fabric.editor.tableHeader.sorting.invalid': 'Je kunt een tabel met samengevoegde cellen niet rangschikken',
  'fabric.editor.tableHeader.sorting.no': 'Geen sortering toegepast op de kolom',
  'fabric.editor.tableOptions': 'Tabelopties',
  'fabric.editor.tableResizeDecreaseScreenReaderInformation':
    '{newWidth, plural, one {Tabelbreedte verminderd tot {newWidth,number} pixel.} other {Tabelbreedte verminderd tot {newWidth,number} pixels.}}',
  'fabric.editor.tableResizeIncreaseScreenReaderInformation':
    '{newWidth, plural, one {Tabelbreedte verhoogd tot {newWidth,number} pixel.} other {Tabelbreedte verhoogd tot {newWidth,number} pixels.}}',
  'fabric.editor.tableSelector': 'Tabelgrootte',
  'fabric.editor.tableSelector.description':
    'Voeg een tabel toe met behulp van een pop-up om een aangepaste indeling te selecteren',
  'fabric.editor.tableSizeSelectorButton': '{numberOfColumns} keer {numberOfRows}',
  'fabric.editor.tableSizeSelectorPopup': 'Selectie voor tabelgrootte',
  'fabric.editor.tables.adjustColumn': 'Kolom aanpassen',
  'fabric.editor.tables.columnResizeLast': 'Je kunt het formaat van deze kolom alleen naar links aanpassen.',
  'fabric.editor.tables.columnResizeOverflow':
    'Je kunt het formaat van deze kolom alleen wijzigen als de tabel een schuifbalk heeft.',
  'fabric.editor.tables.columnWidth':
    '{width, plural, one {Kolombreedte is gewijzigd naar {width} pixel} other {Kolombreedte is gewijzigd naar {width} pixels}}',
  'fabric.editor.tables.confirmDeleteLinkedModalMessage':
    'Als je {nodeName} verwijdert, worden alle koppelingen ernaar verbroken.',
  'fabric.editor.tables.confirmDeleteLinkedModalOKButton': 'Verwijderen',
  'fabric.editor.tables.resizeStop': 'Formaat wijzigen is gestopt',
  'fabric.editor.tables.resizeTable': 'Formaat van tabel wijzigen',
  'fabric.editor.tables.startedColumnResize': 'Wijzigen van het formaat van de kolom is gestart',
  'fabric.editor.task': 'Taak',
  'fabric.editor.taskDecision.markTaskAsCompleted': 'Taak als voltooid markeren',
  'fabric.editor.taskDecision.markTaskAsNotCompleted': 'Taak als niet voltooid markeren',
  'fabric.editor.taskPlaceholder': "Geef je actie in en gebruik een '@' om de actie aan iemand toe te wijzen.",
  'fabric.editor.text.formatting.off': 'Tekst formatteren uit',
  'fabric.editor.textColor': '{selectedColorName} Tekstkleur',
  'fabric.editor.textColorTooltip': 'Tekstkleur',
  'fabric.editor.textFormat': 'Tekst opmaken',
  'fabric.editor.textFormatting': 'Tekstopmaak',
  'fabric.editor.textStyles': '{blockTypeName} Tekststijlen',
  'fabric.editor.textStylesTooltip': 'Tekststijlen',
  'fabric.editor.threeColumns': 'Lay-out van 3 kolommen',
  'fabric.editor.threeColumnsWithLeftSidebars': 'Lay-out van drie kolommen met zijbalken aan de linkerkant',
  'fabric.editor.threeColumnsWithRightSidebars': 'Lay-out van drie kolommen met zijbalken aan de rechterkant',
  'fabric.editor.threeColumnsWithSidebars': 'Lay-out van drie kolommen met zijbalken',
  'fabric.editor.time.ago': 'geleden',
  'fabric.editor.time.updated': 'Bijgewerkt',
  'fabric.editor.time.viewed': 'Bekeken',
  'fabric.editor.toolbarAppears': 'Werkbalk verschijnt',
  'fabric.editor.toolbarLabel': 'Editor',
  'fabric.editor.toolbarMediaTitle': 'Afbeelding, video of bestand toevoegen',
  'fabric.editor.toolbarPositionFixedAtTop': 'Bovenaan vastgezet',
  'fabric.editor.toolbarPositionInline': 'Inline met tekst',
  'fabric.editor.toolbarPositionPinedAtTop': 'Losmaken van taakbalk',
  'fabric.editor.toolbarPositionUnpined': 'Vastmaken aan de taakbalk bovenaan',
  'fabric.editor.tooltip.blockPanel': 'een paneel',
  'fabric.editor.tooltip.bulletList': 'een lijst',
  'fabric.editor.tooltip.decisionList': 'een besluitenlijst',
  'fabric.editor.tooltip.defaultBlockNode': 'een blokknooppunt',
  'fabric.editor.tooltip.nestedExpand': 'een geneste uitgeklapte knooppunt',
  'fabric.editor.tooltip.taskList': 'een actiepunt',
  'fabric.editor.turnInto': 'Omzetten in',
  'fabric.editor.twoColumns': 'Lay-out van 2 kolommen',
  'fabric.editor.typeAhead.popupLabel': 'Resultaten typeahead',
  'fabric.editor.typeAhead.quickInsertInputLabel':
    'Begin te typen om te zoeken of om te filteren op opties voor sneltoetsen',
  'fabric.editor.typeAhead.quickInsertInputPlaceholderLabel': 'Zoeken',
  'fabric.editor.typeAhead.quickInsertPopupLabel': 'Sneltoetsen voor invoegen en opmaak',
  'fabric.editor.typeAheadErrorFallbackDescription': 'Probeer het opnieuw.',
  'fabric.editor.typeAheadErrorFallbackHeading': 'Er is iets misgegaan.',
  'fabric.editor.typeahead.emojiInputLabel': 'Begin te typen om te zoeken of om te filteren op opties voor emoticons',
  'fabric.editor.typeahead.emojiListItemLabel': 'Tekstsneltoets {shortcut} voor de {name} emoticon',
  'fabric.editor.typeahead.emojiPopupLabel': 'Sneltoetsen voor emoticons',
  'fabric.editor.typeahead.mentionInputLabel': 'Begin te typen om naar gebruikers te zoeken om te taggen',
  'fabric.editor.typeahead.mentionPopupLabel': 'Gebruikers die je kunt taggen',
  'fabric.editor.typeahead.metionListItemLabel': 'Gebruiker {name} @{shortName}',
  'fabric.editor.unableToLoadContent': 'We konden deze inhoud niet laden',
  'fabric.editor.unableToOpenLink': 'Kan deze link niet openen',
  'fabric.editor.underline': 'Onderstreept',
  'fabric.editor.undo': 'Maak ongedaan',
  'fabric.editor.unknown.label': 'Onbekend',
  'fabric.editor.unlink': 'Verwijder link',
  'fabric.editor.unorderedList': 'Opsommingslijst',
  'fabric.editor.unorderedList.description': 'Een niet-gesorteerde lijst maken',
  'fabric.editor.unsupportedBlockContent': 'Deze editor ondersteunt weergave van deze inhoud niet',
  'fabric.editor.unsupportedContentTooltip':
    'Inhoud is niet beschikbaar in deze editor. Dit wordt behouden als je bewerkt en opslaat',
  'fabric.editor.unsupportedInlineContent': 'Niet-ondersteunde inhoud',
  'fabric.editor.upDown':
    'Als je de pijltjestoetsen omhoog en omlaag gebruikt in het volgende invoerveld, wordt de datum hieronder bijgewerkt',
  'fabric.editor.url': 'URL weergeven',
  'fabric.editor.urlDescription': 'Link als URL weergeven',
  'fabric.editor.urlTitle': 'URL',
  'fabric.editor.useMarkdown': 'Gebruik Markdown',
  'fabric.editor.viewAndAddCommentsOnMedia': 'Opmerkingen bekijken en toevoegen',
  'fabric.editor.viewCommentOnMedia': 'Opmerkingen bekijken',
  'fabric.editor.viewMore': 'Meer bekijken',
  'fabric.editor.viewMoreAriaLabel': 'Alle elementen bekijken',
  'fabric.editor.visit': 'Link openen in een nieuw venster',
  'fabric.editor.warning': 'Waarschuwing',
  'fabric.editor.warningPanel': 'Waarschuwingspaneel',
  'fabric.editor.warningPanel.description': 'Een waarschuwing toevoegen in een gekleurd paneel',
  'fabric.editor.wrapLeft': 'Links uitlijnen',
  'fabric.editor.wrapRight': 'Rechts uitlijnen',
  'fabric.emoji.label': 'Emoticon',
  'fabric.theme.blue': 'Blauw',
  'fabric.theme.bold-blue': 'Fel blauw',
  'fabric.theme.bold-gray': 'Fel grijs',
  'fabric.theme.bold-green': 'Fel groen',
  'fabric.theme.bold-magenta': 'Fel magenta',
  'fabric.theme.bold-orange': 'Fel oranje',
  'fabric.theme.bold-purple': 'Fel paars',
  'fabric.theme.bold-red': 'Fel rood',
  'fabric.theme.bold-teal': 'Fel blauwgroen',
  'fabric.theme.bold-yellow': 'Fel geel',
  'fabric.theme.bolder-blue': 'Feller blauw',
  'fabric.theme.bolder-gray': 'Feller grijs',
  'fabric.theme.bolder-green': 'Feller groen',
  'fabric.theme.bolder-magenta': 'Feller magenta',
  'fabric.theme.bolder-orange': 'Feller oranje',
  'fabric.theme.bolder-purple': 'Feller paars',
  'fabric.theme.bolder-red': 'Feller rood',
  'fabric.theme.bolder-teal': 'Feller groenblauw',
  'fabric.theme.bolder-yellow': 'Feller geel',
  'fabric.theme.dark-blue': 'Donkerblauw',
  'fabric.theme.dark-gray': 'Donkergrijs',
  'fabric.theme.dark-green': 'Donkergroen',
  'fabric.theme.dark-purple': 'Donkerpaars',
  'fabric.theme.dark-red': 'Donkerrood',
  'fabric.theme.dark-teal': 'Donker blauwgroen',
  'fabric.theme.dark-yellow': 'Donkergeel',
  'fabric.theme.default': 'Standaard',
  'fabric.theme.gray': 'Grijs',
  'fabric.theme.green': 'Groen',
  'fabric.theme.light-blue': 'Lichtblauw',
  'fabric.theme.light-gray': 'Lichtgrijs',
  'fabric.theme.light-green': 'Lichtgroen',
  'fabric.theme.light-purple': 'Lichtpaars',
  'fabric.theme.light-red': 'Lichtrood',
  'fabric.theme.light-teal': 'Licht blauwgroen',
  'fabric.theme.light-yellow': 'Lichtgeel',
  'fabric.theme.lime': 'Limoengroen',
  'fabric.theme.magenta': 'Magenta',
  'fabric.theme.no-color': 'Geen markering',
  'fabric.theme.orange': 'Oranje',
  'fabric.theme.purple': 'Paars',
  'fabric.theme.red': 'Rood',
  'fabric.theme.subtle-blue': 'Licht blauw',
  'fabric.theme.subtle-gray': 'Licht grijs',
  'fabric.theme.subtle-green': 'Licht groen',
  'fabric.theme.subtle-magenta': 'Licht magenta',
  'fabric.theme.subtle-orange': 'Licht oranje',
  'fabric.theme.subtle-purple': 'Licht paars',
  'fabric.theme.subtle-red': 'Licht rood',
  'fabric.theme.subtle-teal': 'Licht blauwgroen',
  'fabric.theme.subtle-yellow': 'Licht geel',
  'fabric.theme.teal': 'Groenblauw',
  'fabric.theme.white': 'Wit',
  'fabric.theme.yellow': 'Geel',
  'fabrid.editor.rowNumbers': 'Rijnummers',
  'rovo.agents.dropdown.title': 'Agents',
  'rovo.agents.dropdown.viewAgents.label': 'Alle agents bekijken',
};
